import { useNavigate } from 'react-router-dom';
import { useBooking } from '../../context/contexts';
import { icn_right_arrow } from '../../imports';
import './CarTypes.css';

const CarTypes = () => {
    const navigate = useNavigate();
    const { 
        selectCar, 
        vehicleTypes, 
        loadingVehicles, 
        vehiclesError 
    } = useBooking();

    const handleCarSelect = (car) => {
        selectCar(car);
        navigate('/booking');
    };

    if (loadingVehicles) {
        return <div className="loading">Loading vehicle types...</div>;
    }

    if (vehiclesError) {
        console.error('Error loading vehicles:', vehiclesError);
        return (
            <div className="error">
                <p>Error loading vehicle types. Please try again later.</p>
                <button onClick={() => window.location.reload()}>Retry</button>
            </div>
        );
    }

    if (!vehicleTypes || vehicleTypes.length === 0) {
        return (
            <div className="error">
                <p>No vehicle types available. Please try again later.</p>
                <button onClick={() => window.location.reload()}>Retry</button>
            </div>
        );
    }

    return (
        <div className="car-type-container">
            <div className="car-type-header">
                <p className='car-type-pre-header'>TAKING CARE OF EVERY CAR</p>
                <h1 className='car-type-header'>Select your car type</h1>
            </div>
            <div className="car-type-content">
                {vehicleTypes.map((car) => (
                    <div 
                        className='car-type-detail' 
                        key={car.id}
                        onClick={() => handleCarSelect(car)}
                        style={{ cursor: 'pointer' }}
                    >
                        <div className="car-type-texts-container">
                            <div className="car-type-texts">
                                <p className="car-type-title">{car.title}</p>
                                <p className="car-type-price">
                                    ${car.defaultPrice || 'N/A'}
                                </p>
                            </div>
                            <div className="car-type-icn">
                                <img src={icn_right_arrow} alt="right arrow" />
                            </div>
                        </div>
                        <div className="car-type-image-container">
                            <img 
                                src={car.image_url} 
                                alt={car.title}
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = 'https://via.placeholder.com/200x150?text=No+Image';
                                }}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CarTypes;